import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class QBuiltConstants {
    //facility Checklist Page
    checklistTableTitle: string = "Facility Checklists";
    checklistTableNew: string = "Click '+' in top right hand corner of table to create a new Inspection Checklist";
    tableauLinkText: string = "Tableau Dashboard Link";
    activeChecklistTrue: string = "Yes";
    activeChecklistFalse: string = "No";

    //global
    saveTopText: string = 'You are about to save your checklist';
    saveMiddleText: string = "If this checklist is set to 'Active' all inspections created after save will use the configuration saved here";
    saveBottomText: string = 'Are you sure you want to proceed?';
    breadcrumbTextHome: string = 'CQMS';
    checklistTitle: string = 'Checklist Name:';
    commentTitle: string = 'Comments:';
    checklistNamePlaceholder: string = 'Enter Checklist Name...';
    commentPlaceholder: string = 'Enter Checklist Comments...';
    saveDisabledTooltip: string = 'Checklist must have Name, all required Standards and no empty Stations to save';

    //unsaved changes dialog
    dialogTitle: string = 'Unsaved Changes';
    dialogMessage: string = 'You have unsaved changes. Are you sure you want to leave without saving?';
    cancelButtonText: string = 'Cancel';
    confirmButtonText: string = 'Proceed';

    //New checklist Page
    breadcrumbTextNew: string = '/ New Checklist';
    stepperText1: string = 'Enter Checklist Details';
    stepperText2: string = 'Required Items';
    stepperText3: string = 'Optional Items';
    stepperText4: string = 'Save';

    //Edit checklist Page
    breadcrumbTextEdit: string = '/ Edit Checklist';
    stepperTextEdit: string = 'Edit Checklist Details';

    //buttons
    saveButtonText: string = 'Save';
    backButtonText: string = 'Back';
    nextButtonText: string = 'Next';
    

}